import voteReportApi from '~/clientApis/reportApi';
import { showMessageModal } from '~/clientUtils/showMessageModal';
import { GetUserVoteCountRequest } from '~/definitions/report';
import { getStore } from '~/mobx/AppStore';

const fetchUserVoteCounts = async (): Promise<void> => {
    const { adminReportStore, generalSettingsStore } = getStore();
    const params: GetUserVoteCountRequest = {
        group_by: 'company',
        year: generalSettingsStore.getSelectedElectionYear(),
    };

    adminReportStore.setIsLoadingUserVoteCounts(true);

    try {
        const response = await voteReportApi.getUserVoteCount(params);
        adminReportStore.setUserVoteCounts(response?.data);
    } catch {
        showMessageModal('error', 'Failed to fetch user vote counts');
    } finally {
        adminReportStore.setIsLoadingUserVoteCounts(false);
    }
};

export default fetchUserVoteCounts;
